import React, { useCallback, useState } from 'react';
import {
  FieldCheckBox,
  FieldDatepicker,
  FieldInput,
  FormCol,
  FormCol2,
  FormCol6,
  FormRow,
  toastFailure,
  toastSuccess,
} from 'motion-components';
import { useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';
import { useRootStore } from 'store';
import { Button, Col } from 'react-bootstrap';
import { FaGlobeEurope } from 'react-icons/fa';
import { useGeocodeCollectionPoint } from './geocode-collection-point-hook';
import { FieldSelectGpsUpdateType } from 'shared-pages/components';

export const GeocodingFormFields = ({ isNew, data, canEdit }) => {
  const { t } = useTranslation();
  const { appStore } = useRootStore();
  const frmkCntx = useFormikContext();
  const { values, setFieldValue } = frmkCntx;

  const geoLabel = (label) => {
    if (data && data.latitude && data.longitude) {
      return (
        <a
          href={`https://www.google.com/maps/search/?api=1&query=${data.latitude},${data.longitude}`}
          target="_blank"
          rel="noreferrer"
        >
          {label}
        </a>
      );
    } else return label;
  };

  const { geocodeCollectionPoint } = useGeocodeCollectionPoint();
  const doGeocodeCollectionPoint = useCallback(async () => {
    if (isNew) return;
    function constructGeocodingAddress(rec: any): string {
      return `${rec.addressLine1},${rec.postalCode}, ${rec.addressCity}`;
    }
    const addr = constructGeocodingAddress(values);
    const geo = await geocodeCollectionPoint(parseInt(data.id), addr);
    if (!geo) {
      toastFailure('Λάθος στο Geocoding του σημείου');
      return;
    }
    toastSuccess('Ολοκληρώθηκε το Geocoding του σημείου');
    setFieldValue('latitude', geo.latitude);
    setFieldValue('longitude', geo.longitude);
    setFieldValue('gpsSource', 'Εύρεση απο την διεύθυνση');
    setFieldValue('gpsDate', new Date());
    // refetch();
  }, [data, geocodeCollectionPoint, values]);

  /**
   * Render
   */
  return (
    <>
      <div className="d-flex flex-row">
        <FormCol>
          <FieldCheckBox
            disabled={!canEdit && !appStore.isPlatformOwner && !isNew}
            as={"div"}
            label={t('Ορατό στον Χάρτη')}
            name="isPubliclyVisibleInMap"
            onLabel={t('ΝΑΙ')}
            offLabel={t('ΟΧΙ')}
          />
        </FormCol>
        <FormCol>
          <FieldInput
            label={geoLabel(t('Γεωγραφικό μήκος (Longitude)'))}
            name="longitude"
            placeholder=""
            disabled={!canEdit}
          />
        </FormCol>
        <FormCol>
          <FieldInput
            label={geoLabel(t('Γεωγραφικό πλάτος (Latitude)'))}
            name="latitude"
            placeholder=""
            disabled={!canEdit}
          />
        </FormCol>
        <FormCol className="d-grid">
          <Button
            variant="outline-secondary"
            onClick={() => {
              doGeocodeCollectionPoint();
            }}
            style={{ marginTop: '0.2rem', height: '2.3rem' }}
            disabled={!canEdit}
          >
            <FaGlobeEurope />
            <span style={{ verticalAlign: 'middle' }}>
              {' '}
              Geocode - {t('Εύρεση Συντεταγμένων Σημείου')}
            </span>
          </Button>
        </FormCol>
      </div>
      <div className="d-flex flex-row">
        <FieldSelectGpsUpdateType
          as={Col}
          name={'gpsUpdateId'}
          defaultValues={{ data }}
          disabled={!canEdit}
        />
        <FormCol className="col-md">
          <FieldDatepicker
            label={t('Ημερομηνία Ενημέρωσης Συντεταγμένων')}
            name="gpsDate"
            disabled={true}
          />
        </FormCol>
        <FormCol>
          <FieldInput
            label={geoLabel(t('Λόγος Τελευταίας Ενημέρωσης'))}
            name="gpsSource"
            placeholder=""
            disabled={true}
          />
        </FormCol>
        <FormCol></FormCol>
      </div>
    </>
  );
};
